import { useEffect } from 'react';

// Google Analytics ID
const GA_MEASUREMENT_ID = 'G-K6YLZ8ZCJN';

// Check if we're in production mode
const isProduction = process.env.NODE_ENV === 'production' && 
                     process.env.REACT_APP_DEV_MODE !== 'true';

/**
 * Initialize Google Analytics
 * Only loads in production environment
 */
const initGoogleAnalytics = () => {
    if (!isProduction) {
        console.log('Google Analytics disabled (not in production)');
        return;
    }

    // Create script element for gtag.js
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    // Initialize dataLayer and gtag function
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);

    console.log('Google Analytics initialized:', GA_MEASUREMENT_ID);
};

/**
 * GoogleAnalytics component
 * Auto-initializes GA when mounted (only in production)
 */
function GoogleAnalytics() {
    useEffect(() => {
        initGoogleAnalytics();
    }, []);

    return null; // This component doesn't render anything
}

/**
 * Track a custom event in Google Analytics
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Event parameters
 */
export const trackEvent = (eventName, eventParams = {}) => {
    if (!isProduction || !window.gtag) {
        console.log('GA Event (not tracked):', eventName, eventParams);
        return;
    }

    window.gtag('event', eventName, eventParams);
    console.log('GA Event tracked:', eventName, eventParams);
};

/**
 * Track a page view in Google Analytics
 * @param {string} pagePath - Page path
 * @param {string} pageTitle - Page title (optional)
 */
export const trackPageView = (pagePath, pageTitle = null) => {
    if (!isProduction || !window.gtag) {
        console.log('GA PageView (not tracked):', pagePath);
        return;
    }

    const params = {
        page_path: pagePath
    };
    
    if (pageTitle) {
        params.page_title = pageTitle;
    }

    window.gtag('config', GA_MEASUREMENT_ID, params);
    console.log('GA PageView tracked:', pagePath, pageTitle);
};

export default GoogleAnalytics;
